import { Globe, LayoutTemplate, Cloud, Smartphone, Gamepad2, Brain, Workflow, TrendingUp, ShieldCheck } from 'lucide-react';

const WHATSAPP_NUMBER = '971504977224';

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const services = [
  {
    icon: Globe,
    tag: 'Web Development',
    title: 'Websites',
    slug: 'website-development-dubai',
    description: 'Custom-built, high-performance websites engineered for speed, scalability, and conversion — from corporate sites to complex multi-page platforms, fully responsive and optimized for search engines.',
    features: ['Responsive design for all devices', 'SEO-optimized architecture', 'Fast load times & clean code', 'Content management systems'],
    waMessage: "Hi Jotunheims! I'm interested in developing a Website for my business. I'd like more information about the process, timelines, and pricing."
  },
  {
    icon: LayoutTemplate,
    tag: 'Conversion-Focused',
    title: 'Landing Pages',
    slug: 'landing-page-design-dubai',
    description: 'High-converting landing pages designed with a single goal: turning visitors into customers. Built with persuasive copy, strategic layout, and conversion-rate optimization best practices.',
    features: ['Conversion-rate optimized layouts', 'A/B testing ready structures', 'Fast deployment & launch', 'Integrated lead capture forms'],
    waMessage: "Hi Jotunheims! I need a high-converting Landing Page for a campaign/product. Could you give me more details about the service and pricing?"
  },
  {
    icon: Cloud,
    tag: 'Scalable Platforms',
    title: 'SaaS Platforms',
    slug: 'saas-development-dubai',
    description: 'Full-stack SaaS product development — from MVP to enterprise-grade platforms. We handle architecture, database design, authentication, billing, and everything needed to launch a scalable subscription business.',
    features: ['Multi-tenant architecture', 'Subscription & billing integration', 'Secure authentication & roles', 'Cloud infrastructure & scaling'],
    waMessage: "Hi Jotunheims! I have an idea for a SaaS Platform and want to know how you can help me build it from MVP to production."
  },
  {
    icon: Smartphone,
    tag: 'iOS & Android',
    title: 'Mobile Applications',
    slug: 'mobile-app-development-dubai',
    description: 'Native or cross-platform iOS & Android apps — we recommend the best fit for your product. Polished UI, smooth performance, and full backend integration for real-world business use.',
    features: ['Native or cross-platform iOS & Android apps', 'Push notifications & offline support', 'App Store & Play Store deployment', 'Backend & API integration'],
    waMessage: "Hi Jotunheims! I want to develop a Mobile Application for iOS and Android. Could you tell me about the development process and costs?"
  },
  {
    icon: Gamepad2,
    tag: 'Interactive Entertainment',
    title: 'Games',
    slug: 'game-development-uae',
    description: 'End-to-end game development across genres and platforms — 2D, 3D, mobile, or web-based. From concept art and mechanics design to full production, powered by our in-house game development expertise.',
    features: ['2D & 3D game development', 'Multiplayer & monetization systems', 'Web, mobile & desktop builds', 'Character & world design'],
    waMessage: "Hi Jotunheims! I have a Video Game project I want to develop. I'd like to talk about scope, platforms, and budget."
  },
  {
    icon: Brain,
    tag: 'Tailored Intelligence',
    title: 'Custom AI',
    slug: 'custom-ai-solutions-dubai',
    description: 'Bespoke artificial intelligence solutions built around your business — from AI assistants and chatbots to predictive models and automated decision engines, trained on your own data.',
    features: ['Custom-trained AI models', 'Chatbots & virtual assistants', 'Predictive analytics engines', 'Seamless API integrations'],
    waMessage: "Hi Jotunheims! I'm interested in developing a Custom AI solution for my business. Could you give me more information?"
  },
  {
    icon: Workflow,
    tag: 'Operational Efficiency',
    title: 'Business Automations',
    slug: 'business-automation-dubai',
    description: 'We streamline your operations by automating repetitive workflows — from customer communication to internal processes — freeing your team to focus on growth instead of manual tasks.',
    features: ['Workflow & process automation', 'CRM & tool integrations', 'Automated reporting & alerts', 'Time & cost savings analysis'],
    waMessage: "Hi Jotunheims! I want to automate processes in my business. Could you explain what type of Automations you can implement?"
  },
  {
    icon: TrendingUp,
    tag: 'Growth & Reach',
    title: 'Digital Marketing',
    slug: 'digital-marketing-dubai',
    description: 'Full-funnel digital marketing strategies that drive real growth — social media management, paid advertising, SEO, and content strategy designed to expand your brand and generate qualified leads.',
    features: ['Social media & content strategy', 'Paid ads (Meta, Google, TikTok)', 'SEO & organic growth', 'Analytics & performance reporting'],
    waMessage: "Hi Jotunheims! I need help with Digital Marketing for my brand or business. Could you give me more information about your services?"
  },
  {
    icon: ShieldCheck,
    tag: 'Powered by 0Logic AI',
    title: 'Cybersecurity',
    slug: 'cybersecurity-ai-uae',
    description: 'Enterprise-grade cybersecurity powered by our own 0Logic AI — real-time threat detection, vulnerability assessments, and autonomous defense systems that protect your infrastructure around the clock.',
    features: ['24/7 AI-powered threat monitoring', 'Vulnerability & penetration testing', 'Incident response & remediation', 'Infrastructure hardening'],
    waMessage: "Hi Jotunheims! I'm interested in your Cybersecurity services powered by 0Logic AI. I'd like more information on how to protect my infrastructure."
  }
];

export const generalWaMessage = "Hi Jotunheims! I'd like to get more information about your services and how you can help my business.";

export const projectTypeOptions = [
  'Website',
  'Landing Page',
  'Online Store',
  'SaaS',
  'App',
  'Game',
  'Custom AI',
  'Business Automation',
  'Digital Marketing',
  'Cybersecurity'
];

export const buildServiceRequestMessage = ({ name, email, phone, project_types, description, budget }, es = false) => {
  const L = es
    ? ['Nueva solicitud de proyecto desde la web', 'Nombre', 'Correo', 'Teléfono', 'Tipo(s) de proyecto', 'Descripción del proyecto', 'Presupuesto', 'No especificado']
    : ['New Project Request from the Website', 'Name', 'Email', 'Phone', 'Project Type(s)', 'Project Description', 'Budget', 'Not specified'];
  return `${L[0]}\n\n${L[1]}: ${name}\n${L[2]}: ${email}\n${L[3]}: ${phone}\n` +
    `${L[4]}: ${(project_types || []).join(', ')}\n\n${L[5]}:\n${description}\n\n${L[6]}: ${budget || L[7]}`;
};